{
  "name": "sipub-frontend",
  "version": "3.5.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prepare:mock-dashboard": "node tools/mock-server/scripts/generate-public-dashboard-static-mock.js",
    "prebuild": "npm run prepare:mock-dashboard",
    "prebuild-dev": "npm run prepare:mock-dashboard",
    "build": "ng build",
    "build-dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "mock:install": "npm ci --prefix tools/mock-server",
    "mock:start": "npm start --prefix tools/mock-server",
    "serve:ssr:sipub-frontend": "node dist/sipub-frontend/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.2",
    "@angular/cdk": "^22.1.2",
    "@angular/common": "^22.1.2",
    "@angular/compiler": "^22.1.2",
    "@angular/core": "^22.1.2",
    "@angular/forms": "^22.1.2",
    "@angular/google-maps": "^22.1.2",
    "@angular/material": "^22.1.2",
    "@angular/platform-browser": "^22.1.2",
    "@angular/platform-server": "^22.1.2",
    "@angular/router": "^22.1.2",
    "@angular/ssr": "^22.1.4",
    "@googlemaps/markerclusterer": "^2.5.3",
    "@types/sql.js": "^1.4.11",
    "@types/three": "^0.183.1",
    "angular-svg-icon": "^19.1.1",
    "apexcharts": "^5.3.6",
    "express": "^4.18.2",
    "hls.js": "^1.6.15",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.8",
    "jsqr": "^1.4.0",
    "jszip": "^3.10.1",
    "lottie-web": "^5.12.2",
    "multer": "^2.0.2",
    "ng-apexcharts": "^2.5.0",
    "ngx-captcha": "^14.0.0",
    "ngx-lottie": "^22.0.0",
    "ngx-mask": "^22.1.0",
    "nipplejs": "^1.0.1",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "sax": "^1.6.1",
    "selfsigned": "^2.4.1",
    "sql.js": "^1.14.2",
    "supercluster": "^8.0.1",
    "swagger-ui-express": "^5.0.1",
    "three": "^0.183.2",
    "three-stdlib": "^2.36.1",
    "tslib": "^2.3.0",
    "uuid": "^8.3.2",
    "xlsx": "^0.18.5",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^22.1.4",
    "@angular/cli": "^22.1.4",
    "@angular/compiler-cli": "^22.1.2",
    "@types/express": "^4.17.17",
    "@types/grecaptcha": "^3.0.9",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.20.1",
    "@types/qrcode": "^1.5.6",
    "@types/sax": "^1.2.7",
    "@types/supercluster": "^7.1.3",
    "@types/uuid": "^10.0.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~6.0.3"
  }
}
